export { default } from './partner-info';
export { partnerInfoHandler } from './partner-info.handler';
export { partnerInfoQuery } from './partner-info.query';
